import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import './consentForm.css'; // Assuming you'll use the CSS from the previous answer
// import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import { Container, ContentWithVerticalPadding } from "components/misc/Layouts.js";
import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial2.js";
import ConsentMessages from "components/cta/ConsentForMessages.js";
import Footer from "components/footers/MiniCenteredFooter.js";

const HighlightedText = tw.span`text-primary-500`


const ConsentForm = () => {
  // Destructure properties from useForm
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    // Set default values to prevent uncontrolled component warnings
    defaultValues: {
      phoneNumber: '',
      consent: false,
    },
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  // Function to handle form submission
  const onSubmit = async (data) => {
    // 1. --- Twilio Opt-In Data Capture (Server-Side Action) ---
    // In a production application, you would send the data to your *server*
    // to record the consent evidence (IP, Timestamp, Phone Number, etc.)
    console.log('--- Submitting Twilio Consent Data ---');
    console.log('Data Captured:', data);
    console.log('NOTE: A real app would save this data to a database for Twilio audit.');
    
    // Simulate API call success/failure
    const serverSuccess = true; 

    if (!serverSuccess) {
        toast.error('Opt-in failed. Please try again.');
        return;
    }


    // 2. --- Email Notification (Optional - using EmailJS) ---
    // This part is for sending a notification email, often used to alert the business.
    const serviceID = process.env.REACT_APP_SERVICE_ID;
    const templateID = process.env.REACT_APP_TEMPLATE_ID;
    const userID = process.env.REACT_APP_USER_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    const templateParams = {
        name: data.phoneNumber,
        email: 'mobile-consent@belleit.net',
        subject: `BelleIT.net consent ${data.phoneNumber} ${data.consent}`,
        message: `BelleIT.net mobile phone consent ${data.phoneNumber} ${data.consent}`
    };

    try {
        emailjs.init(publicKey);
        await emailjs.send(serviceID, templateID, templateParams, userID);
        toast.success('Success! Your mobile number has been subscribed to Belle IT account notifications. You will receive clinic updates and important announcements. Reply STOP to cancel.');
        
        // Show the success message on the form
        setFormSubmitted(true);
        reset(); // Clear the form fields
    } catch (error) {
        console.error('EmailJS Error:', error);
        // Do not clear the form if the notification email fails, only if the Twilio process succeeds.
        toast.error('Opt-in recorded, but failed to send notification email.');
        setFormSubmitted(true); // Still show success if Twilio step succeeded
    }
  };

  if (formSubmitted) {
    return (
        <div className="consent container2">
            <h1>Opt-In Confirmed</h1>
            <div id="successMessage" className="success-box">
                <p>✅ Success! Your number has been subscribed to Belle IT account notifications.</p>
                <p>You’ll receive clinic updates and important announcements. Reply STOP to cancel.</p>
                <p className="disclaimer-note">This form successfully captured the legally required proof of consent.</p>
                <button onClick={() => setFormSubmitted(false)}>Sign Up Another Number</button>
            </div>
            <ToastContainer />
        </div>
    );
  }

  return (
      <AnimationRevealPage>
    <Container>
      <Hero />
    <div className="consent container2">
      <h1>Welcome! Text message Consent Form</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="opt-in-form">
        <label htmlFor="phoneNumber">Mobile Phone Number:</label>
        <input
          type="tel"
          id="phoneNumber"
          placeholder="(555) 555-5555"
          {...register('phoneNumber', {
            required: 'A phone number is required.',
            pattern: {
              // Basic regex for US phone format (10 or 11 digits, optional dashes/spaces/parens)
              value: /^\+?(\d{1,3})?[-.\s]?(\(?\d{3}\)?)[-.\s]?(\d{3})[-.\s]?(\d{4})$/,
              message: 'Invalid phone number format.',
            },
          })}
        />
        {errors.phoneNumber && <p className="error-message">{errors.phoneNumber.message}</p>}

        <div className="consent-text">
          <input
            type="checkbox"
            id="consent"
            {...register('consent', {
              required: 'You must provide explicit consent to opt-in.',
            })}
          />
          <label htmlFor="consent">
            By entering your mobile number and clicking Sign Up, you agree to receive automated text messages regarding clinic hours, appointment updates, and general operational notifications. No personal or private health information will be included. Msg & data rates may apply. Reply STOP to opt-out.
          </label>
        </div>
        {errors.consent && <p className="error-message">{errors.consent.message}</p>}

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Signing Up...' : 'Sign Up'}
        </button>

        <p className="disclaimer">By submitting, you consent to receive SMS messages from Belle IT.</p>
      </form>

      <ToastContainer />
    </div>
       </Container>
       <Footer />
     
     </AnimationRevealPage>
  );
};

export default ConsentForm;